import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
    providedIn: 'root'
})
export class CuFamilyService extends ApiService {

    index(params: any = {}) {
        return super.get('/cu-families', params);
    }

    store(body: any) {
        return super.post('/cu-families', body);
    }

    edit(cuFamilyId: number) {
        return super.get(`/cu-families/${cuFamilyId}/edit`);
    }

    update(cuFamilyId: number, body: any) {
        return super.put(`/cu-families/${cuFamilyId}`, body);
    }

    destroy(cuFamilyId: number) {
        return super.delete(`/cu-families/${cuFamilyId}`);
    }

    select(params: any = {}) {
        return super.get('/cu-families/select', params);
    }
}
